// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .controller('GraficosBaseCtrl', GraficosBaseCtrl);

    GraficosBaseCtrl.$inject = ['$log', '$scope'];
    export default function GraficosBaseCtrl($log, $scope) {

        var TAG = 'GraficosBaseCtrl: ';
        var vm = this;

        vm.actualizarFiltros = function (valor) {
            $scope.$broadcast('CAMBIA_FILTROS', valor);
        };
    }
// })();